export default __webpack_public_path__ + "static/media/errormsg.abc12e14.gif";